import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import InfoPage from "@/pages/InfoPage";
import ContactPage from "@/pages/ContactPage";
import Checkout from "@/pages/Checkout";
import PaymentResult, { PaymentCancel } from "@/pages/PaymentResult";
import OrderLookup from "@/pages/OrderLookup";
import AdminCoupons from "@/pages/admin/AdminCoupons";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminLogin from "@/pages/admin/AdminLogin";
import { AdminForgotPassword, AdminResetPassword } from "@/pages/admin/AdminPasswordReset";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductEdit from "@/pages/admin/AdminProductEdit";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminShipping from "@/pages/admin/AdminShipping";
import AdminImport from "@/pages/admin/AdminImport";
import AdminHomepage from "@/pages/admin/AdminHomepage";

const NotFound = () => (
  <div className="py-32 text-center" data-testid="not-found-page">
    <h1 className="font-display text-4xl font-semibold">Pagina non trovata</h1>
    <Link to="/" className="mt-6 inline-block text-[#4D94FF]">Torna alla home</Link>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/categoria/:slug" element={<Catalog />} />
            <Route path="/prodotto/:slug" element={<Product />} />
            <Route path="/carrello" element={<Cart />} />
            <Route path="/pagina/:slug" element={<InfoPage />} />
            <Route path="/pagina/contatti" element={<ContactPage />} />
            <Route path="/contatti" element={<ContactPage />} />
            <Route path="/assistenza" element={<ContactPage support />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pagamento/esito" element={<PaymentResult />} />
            <Route path="/pagamento/annullato" element={<PaymentCancel />} />
            <Route path="/ordine" element={<OrderLookup />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AuthProvider><AdminLogin /></AuthProvider>} />
          <Route path="/admin/password-dimenticata" element={<AdminForgotPassword />} />
          <Route path="/admin/reimposta-password" element={<AdminResetPassword />} />
          <Route path="/admin" element={<AuthProvider><AdminLayout /></AuthProvider>}>
            <Route index element={<AdminDashboard />} />
            <Route path="prodotti" element={<AdminProducts />} />
            <Route path="prodotti/:id" element={<AdminProductEdit />} />
            <Route path="ordini" element={<AdminOrders />} />
            <Route path="spedizioni" element={<AdminShipping />} />
            <Route path="importa" element={<AdminImport />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="coupon" element={<AdminCoupons />} />
            <Route path="richieste" element={<AdminRequests />} />
            <Route path="prezzi" element={<AdminPricing />} />
          </Route>
        </Routes>
      </CartProvider>
      <Toaster position="bottom-center" theme="light" />
    </BrowserRouter>
  );
}

export default App;
